import { render } from "./ChangeTextCredit.vue?vue&type=template&id=31a5a5ca&scoped=true&lang=pug"
import script from "./ChangeTextCredit.vue?vue&type=script&lang=js"
export * from "./ChangeTextCredit.vue?vue&type=script&lang=js"

import "./ChangeTextCredit.vue?vue&type=style&index=0&id=31a5a5ca&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a5a5ca"]])

export default __exports__